var formatDateShort = value => {
  if (value == null || !value) return;
  var d = new Date(value);
  var Y = d.getFullYear() + '-';
  var M = (d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + '-';
  var D = (d.getDate() < 10 ? '0' + (d.getDate()) : d.getDate());
  return Y + M + D;
}

var formatStartDate = value => {
  if (value == null) return;
  var d = new Date(value);
  var Y = d.getFullYear() + '-';
  var M = (d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + '-';
  var D = (d.getDate() < 10 ? '0' + (d.getDate()) : d.getDate());
  return Y + M + D + ' 00:00:00';
}

var formatEndDate = value => {
  if (value == null) return;
  var d = new Date(value);
  var Y = d.getFullYear() + '-';
  var M = (d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + '-';
  var D = (d.getDate() < 10 ? '0' + (d.getDate()) : d.getDate());
  return Y + M + D + ' 23:59:59';
}

var formatDateYYYYMMDD = value => {
  if (value == null || !value) return;
  var d = new Date(value);
  var Y = d.getFullYear();
  var M = (d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1);
  var D = (d.getDate() < 10 ? '0' + (d.getDate()) : d.getDate());
  return Y + M + D;
}
var formatDateYYYYMMDDhhmmss = value => {
  if (value == null || !value) return;
  var d = new Date(value);
  var Y = d.getFullYear();
  var M = (d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1);
  var D = (d.getDate() < 10 ? '0' + (d.getDate()) : d.getDate());
  var H = (d.getHours() < 10 ? '0' + (d.getHours()) : d.getHours());
  var m = (d.getMinutes() < 10 ? '0' + (d.getMinutes()) : d.getMinutes());
  var s = d.getSeconds() < 10 ? '0' + (d.getSeconds()) : d.getSeconds();
  return Y + M + D + H + m + s;
}

var formatDateLong = value => {
  if (value == null || !value) return;
  var d = new Date(value);
  var Y = d.getFullYear() + '-';
  var M = (d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + '-';
  var D = (d.getDate() < 10 ? '0' + (d.getDate()) : d.getDate()) + " ";
  var H = (d.getHours() < 10 ? '0' + (d.getHours()) : d.getHours()) + ":";
  var m = (d.getMinutes() < 10 ? '0' + (d.getMinutes()) : d.getMinutes()) + ":";
  var s = d.getSeconds() < 10 ? '0' + (d.getSeconds()) : d.getSeconds();

  return Y + M + D + H + m + s;
}

var cityFilter = value => {
  if (value == null) return;
  switch (value) {
    case '110100':
      return '北京'
      break;
    case '310100':
      return '上海'
      break;
    case '420100':
      return '武汉'
      break;
    case '440100':
      return '广州'
      break;
    case '320100':
      return '南京'
      break;
    case '340100':
      return '合肥'
      break;
    case '610100':
      return '西安'
      break;
    case '510100':
      return '成都'
      break;
    case '370100':
      return '济南'
      break;
    case '370200':
      return '青岛'
      break;
    case '350200':
      return '厦门'
      break;
    case '130100':
      return '石家庄'
      break;
    case '320500':
      return '苏州'
      break;
    case '500100':
      return '重庆'
      break;
    case '120100':
      return '天津'
      break;
  }
}

export {formatDateShort, formatDateLong, cityFilter, formatStartDate, formatEndDate, formatDateYYYYMMDD,formatDateYYYYMMDDhhmmss}



// WEBPACK FOOTER //
// ./src/utils/filters.js